import React from 'react';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import InviteSvg from './invite.svg';

export default function InviteTeamButton() {
  return (
    <a href='/settings/team/edit'>
      <Button
        id='invite-team-btn'
        className='h-10 py-0 v2-text-neutral-900 v2-bg-green-100 hover:v2-bg-green-200 v2-border-green-100 hover:v2-border-green-200'
        variant={ButtonVariant.Primary}
      >
        <InviteSvg className='h-4 relative top-[3px] mr-2' />
        Invite
      </Button>
    </a>
  );
}
